// @flow
import React, { Component, type Node } from 'react';
import styled from 'styled-components';
import { colors } from '../bench-style-constants';

const BKToolsFallbackUILayout = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

const BKToolsFallbackUIText = styled.div`
  color: ${colors.charcoal};
  font-size: 16px;
  line-height: 24px;
  max-width: 400px;
  padding-top: 14px;
  text-align: center;
`;

const BKToolsFallbackUI = () => (
  <BKToolsFallbackUILayout>
    <BKToolsFallbackUIText>
      Oops, it looks like something went wrong. We’re working on fixing this issue as quickly as we
      can. If you continue to see this message, please contact App Support.
    </BKToolsFallbackUIText>
  </BKToolsFallbackUILayout>
);

type BKToolsErrorBoundaryProps = {
  children: Node,
  clientId: ?string,
  featureName?: ?string,
};

type BKToolsErrorBoundaryState = {
  hasError: boolean,
};

class BKToolsErrorBoundary extends Component<BKToolsErrorBoundaryProps, BKToolsErrorBoundaryState> {
  static defaultProps = {
    featureName: undefined,
  };

  state = {
    hasError: false,
  };

  componentDidCatch(error: Object, info: Object) {
    const { clientId, featureName } = this.props;
    this.setState({ hasError: true });
    if (window.Rollbar.error) {
      window.Rollbar.error(error, { clientId, featureName, ...info });
    }
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return <BKToolsFallbackUI />;
    }
    return children;
  }
}

export default BKToolsErrorBoundary;
